<template lang="pug">
el-dialog#modal-cadastrar-monitoramento-agricola(
    width='500px',
    v-if='mostrar',
    :visible.sync='mostrar',
    :before-close='fechar',
    :close-on-click-modal='false',
    :close-on-press-escape='false',
    :destroy-on-close='true',
    close='fechar'
)
    span(slot='title')
        h1.font-weight-bold {{ $t('mensagens.monitoramentoAgricola.editarMonitoramentoAgricola') }}
        h3.font {{ areaMonitorada?.territorio?.nome }}

    el-form.formContainer.w-100.mb-3.p-0(
        :model='dadosMonitoramento',
        :rules='rules',
        ref='formularioAreasMonitoramento'
    )
        el-form-item.my-3(prop='idSafra', :label="$t('mensagens.territorio.cicloAno')")
            el-select.w-100(
                v-model='dadosMonitoramento.idSafra',
                :placeholder="$t('mensagens.territorio.selecione')",
                value-key='descricao'
            )
                el-option(
                    v-for='ciclo in cicloAno',
                    :key='"cicloAno" + ciclo.descricao',
                    :value='ciclo.id',
                    :label='ciclo.descricao'
                ) {{ ciclo.descricao }}

        el-form-item.my-3(prop='cultura', :label="$t('mensagens.territorio.culturaEsperada')")
            el-select.w-100(
                v-model='dadosMonitoramento.cultura',
                :placeholder="$t('mensagens.territorio.selecione')",
                clearable
            )
                el-option(
                    v-for='cultura in culturas',
                    :key='"cultura" + cultura.id',
                    :value='cultura.id',
                    :label='internacionalizarCulturas(cultura.nome)'
                ) {{ internacionalizarCulturas(cultura.nome) }}

        el-form-item.my-3(
            prop='dataPlantio',
            :label="$t('mensagens.territorio.dataPlantioEsperada')"
        )
            el-date-picker.w-100(
                :disabled="!dadosMonitoramento.cultura"
                v-model='dadosMonitoramento.dataPlantio',
                type='date',
                format='dd/MM/yyyy',
                value-format='yyyy-MM-dd',
                placeholder='',
                clearable
            )

        el-form-item.my-3.inline(
            prop='areaDoPlantio',
            :label="$t('mensagens.territorio.areaPlantioEsperada')"
        )
            el-input-number(
                :disabled="!dadosMonitoramento.cultura"
                v-model='dadosMonitoramento.areaDoPlantio',
                :precision='2',
                :step='0.01',
                :min='0.0'
            )

        el-form-item.my-3.inline(
            prop='produtividade',
            :label="$t('mensagens.territorio.produtividadeEsperada') + formatarUnidadeDeProdutividade()"
        )
            el-input-number(
                :disabled="!dadosMonitoramento.cultura"
                v-model='dadosMonitoramento.produtividade',
                :precision='2',
                :step='0.01',
                :min='0.0'
            )

    div(slot='footer')
        .buttons
            BaseButton(size='mini', @click='fechar')
                | {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(
                type='primary',
                size='mini',
                @click='confirmarMonitoramento'
            )
                | {{ $t('mensagens.comuns.confirmar') }}
    </template>

<script>
import CulturaService from '@/services/CulturaService';
import UtilsService from '@/services/UtilsService';
import { CULTURAS } from '@/utils/TipoCultura';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalCadastrarMonitoramentoAgricola',
    components: {
        BaseButton
    },
    emits: ['cadastrarMonitoramentoAgricola'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        areaMonitorada: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            algodao: null,
            rules: {
                idSafra: [
                    {
                        required: true,
                        message: 'Campo obrigatório.',
                        trigger: 'blur'
                    }
                ]
            },
            culturas: [],
            culturasListagem: [ CULTURAS.SOJA.codigo, CULTURAS.MILHO.codigo, CULTURAS.ALGODAO.codigo ],
            cicloAno: [],
            dadosMonitoramento: {
                cultura: null,
                idSafra: null,
                dataPlantio: null,
                areaDoPlantio: 0,
                produtividade: 0
            }
        };
    },

    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
    },

    watch: {
        mostrar: function () {
            if (this.mostrar) {
                this.preencherCampos();
            } else {
                this.limparCampos();
            }
        }
    },

    methods: {
        buscarCulturas() {
            CulturaService.buscarPorCodigo(this.culturasListagem)
                .then(({ data }) => {
                    setTimeout(() => {
                        Object.keys(data).forEach(item => {
                            this.culturas.push(data[item]);
                            this.culturas.sort((a, b) =>
                                a.nome.localeCompare(b.nome)
                            );
                            if (data[item].codigo === CULTURAS.ALGODAO.codigo) {
                                this.algodao = data[item].id;
                            }
                        });
                    }, 500);
                })
                .catch(error => {
                    this.$notify.error({
                        message: 'Não foi possível buscar os dados de culturas.'
                    });
                    throw error;
                });
        },
        buscarSafras() {
            UtilsService.getSafras().then(response => {
                if (response.status === 200) {
                    this.cicloAno = response.data;
                } else {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao buscar safras'
                    });
                }
            });
        },

        fechar() {
            this.limparCampos();
            this.$emit('fechar');
        },
        confirmarMonitoramento() {
            this.$refs.formularioAreasMonitoramento.validate(async valid => {
                if (valid) {
                    const area = {
                        id: this.areaMonitorada.id,
                        idTerritorio: this.areaMonitorada.territorio.id,
                        dataPlantio: this.dadosMonitoramento.dataPlantio,
                        cultura: this.dadosMonitoramento.cultura,
                        idSafra: this.dadosMonitoramento.idSafra,
                        areaDoPlantio: this.dadosMonitoramento.areaDoPlantio,
                        produtividade: this.dadosMonitoramento.produtividade,
                        tipoMonitoramento: 'AGRICOLA'
                    };

                    this.$emit(
                        'editarMonitoramentoAgricola',
                        area
                    );

                    this.fechar();
                }
            });
        },
        limparCampos() {
            this.dadosMonitoramento = {
                cultura: null,
                idSafra: null,
                dataPlantio: null,
                areaDoPlantio: 0,
                produtividade: 0
            };
        },
        preencherCampos() {

            this.dadosMonitoramento.idSafra = this.areaMonitorada.safra.id;

            if (this.areaMonitorada.culturaEsperada && this.areaMonitorada.culturaEsperada.id !== 0) {
                this.dadosMonitoramento.cultura = this.areaMonitorada.culturaEsperada.id;
            }

            if (this.areaMonitorada.dataPlantioEsperada) {
                const dataSplit = this.areaMonitorada.dataPlantioEsperadaFormatado.split('/');
                this.dadosMonitoramento.dataPlantio = dataSplit[2] + '-' + dataSplit[1] + '-' + dataSplit[0];
            }

            if (this.areaMonitorada.areaPlantadaEsperadaHa) {
                this.dadosMonitoramento.areaDoPlantio = this.areaMonitorada.areaPlantadaEsperadaHa;
            }

            if (this.areaMonitorada.produtividadeEsperadaScHa) {
                this.dadosMonitoramento.produtividade = this.areaMonitorada.produtividadeEsperadaScHa;
            }

        },
        formatarUnidadeDeProdutividade() {
            return this.dadosMonitoramento.cultura !== null && this.dadosMonitoramento.cultura === this.algodao ? ' (@/ha)' : ' (sc/ha)';
        },
        internacionalizarCulturas(cultura) {
            const culturaFormatada = cultura.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
            const culturaFormatadaSemEspacos = culturaFormatada.replace(/\s+/g, '-');
            return this.$t(`mensagens.cultura.${culturaFormatadaSemEspacos}`);
        }
    }
};
</script>

<style lang="scss">
#modal-cadastrar-monitoramento-agricola {
    border-radius: 5px;

    .el-dialog__header {
        background-color: #e9e9e9;
        padding-bottom: 20px;
    }

    .el-dialog__body {
        padding: 0 20px 30px;

        .inline {
            .el-form-item__content {
                text-align: end;
            }
        }
    }

    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>
